export const DEVICE_START = 'device/device-start';
export const DEVICE_SUCCESS = 'device/device-success';
export const DEVICE_ERROR = 'device/device-error';